import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { TALK_STATUS_TYPES, TALK_STATUS_STYLES } from '../../types/talk';

interface TalkStatusChipProps {
  status: keyof typeof TALK_STATUS_TYPES;
  isForceEnd?: boolean;
  tooltipContent?: React.ReactNode;
}

const TalkStatusChip: React.FC<TalkStatusChipProps> = ({ status, isForceEnd, tooltipContent }) => {
  // 対話終了+強制終了の場合は「強制終了」と表示する
  const displayLabel = (status === 'DONE' && isForceEnd) 
    ? '強制終了'
    : TALK_STATUS_TYPES[status] || status;
  
  // ステータスに応じたスタイルを取得
  const statusStyle = (status === 'DONE' && isForceEnd)
    ? TALK_STATUS_STYLES['FORCE_END']
    : TALK_STATUS_STYLES[status];
  
  const chip = (
    <Chip
      label={displayLabel}
      size="small"
      color={statusStyle?.customStyle ? 'default' : (statusStyle?.chipColor || 'default')}
      sx={{ 
        fontWeight: 'bold',
        minWidth: '80px',
        maxWidth: '100%',
        ...(statusStyle?.customStyle && {
          backgroundColor: statusStyle.customStyle.backgroundColor,
          color: statusStyle.customStyle.color,
          borderColor: statusStyle.customStyle.borderColor || statusStyle.customStyle.backgroundColor,
          '&:hover': {
            backgroundColor: statusStyle.customStyle.backgroundColor,
          }
        })
      }}
    />
  );

  // tooltipContentが指定されている場合はTooltipでラップする
  if (tooltipContent) {
    return (
      <Tooltip title={tooltipContent} arrow placement="top">
        {chip}
      </Tooltip>
    );
  }

  return chip;
};

export default TalkStatusChip;